import { useCallback, useEffect, useState } from 'react';
import { useSessionStorage } from 'react-use-storage';

import useTombFinance from './useTombFinance';

const useTotalValueLocked = () => {
  const [sessionTvl, setSessionTvl] = useSessionStorage<number>('tvl', 0);
  const [totalValueLocked, setTotalValueLocked] = useState<number>(0);
  const tombFinance = useTombFinance();

  const fetchTvl = useCallback(async () => {
    try {
      if (sessionTvl) return setTotalValueLocked(Number(sessionTvl));
      const tvl = await tombFinance.getTotalValueLocked();
      setSessionTvl(tvl);
      setTotalValueLocked(tvl);
    } catch (err) {
      console.error(`useTotalValueLocked::fetchTvl() -> ${err}`,err);
    }
  }, [sessionTvl, setSessionTvl, tombFinance]);

  useEffect(() => {
    fetchTvl();
  }, [fetchTvl]);

  return totalValueLocked;
};

export default useTotalValueLocked;
